import type { PositionMarkerProps } from "./position-marker.type";

import Icon from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import MarkerSvg from "./svg/marker.svg?react";

import "./position-marker.style.less";

export const PositionMarker = ({ style }: PositionMarkerProps) => {
  const { t } = useTranslation();
  return (
    <div className="position-marker-wrapper" style={style}>
      <Icon component={MarkerSvg} aria-label={t("global:marker")} />
    </div>
  );
};
